import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [message, setMessage] = useState('Procesando autenticación...');

  useEffect(() => {
    const processCallback = async () => {
      // Check for token from Google OAuth callback
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        setStatus('error');
        setMessage(getErrorMessage(error));
        setTimeout(() => navigate('/auth'), 3000);
        return;
      }

      if (token) {
        // Save token to localStorage
        localStorage.setItem('session_token', token);
        setStatus('success');
        setMessage('¡Autenticación exitosa! Redirigiendo...');
        
        // Trigger storage event for other components
        window.dispatchEvent(new Event('storage'));
        
        setTimeout(() => {
          navigate('/dashboard');
        }, 1500);
      } else {
        setStatus('error');
        setMessage('No se recibió el token de autenticación');
        setTimeout(() => navigate('/auth'), 3000);
      }
    };

    processCallback();
  }, [searchParams, navigate]);

  const getErrorMessage = (error) => {
    const messages = {
      'invalid_state': 'Sesión expirada. Por favor, intenta de nuevo.',
      'expired_state': 'La sesión ha expirado. Por favor, intenta de nuevo.',
      'token_exchange_failed': 'Error al conectar con Google. Por favor, intenta de nuevo.',
      'userinfo_failed': 'No se pudo obtener información de tu cuenta de Google.',
      'no_email': 'Tu cuenta de Google no tiene un email asociado.',
      'server_error': 'Error del servidor. Por favor, intenta de nuevo.',
      'missing_params': 'Parámetros faltantes en la respuesta.'
    };
    return messages[error] || 'Error de autenticación desconocido.';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 max-w-md w-full mx-4 text-center">
        {status === 'processing' && (
          <>
            <Loader2 className="w-16 h-16 text-indigo-600 animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Procesando</h2>
            <p className="text-slate-600">{message}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">¡Éxito!</h2>
            <p className="text-slate-600">{message}</p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Error</h2>
            <p className="text-slate-600">{message}</p>
            <p className="text-sm text-slate-400 mt-4">Redirigiendo a la página de login...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
